import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

// Value in/out is always a 24-hour "HH:MM" string (matches how times are stored and
// compared everywhere else in the app); this just presents the picker as three
// dropdowns — hour, minute, AM/PM — so the format is guaranteed 12-hour with AM/PM
// regardless of the viewer's browser/OS locale.
function parse24h(value) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(value || "");
  if (!m) return { hour: "", minute: "", meridiem: "" };
  const h = parseInt(m[1], 10);
  const meridiem = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return { hour: String(hour12), minute: m[2], meridiem };
}

function to24h(hour12, minute, meridiem) {
  let h = parseInt(hour12, 10) % 12;
  if (meridiem === "PM") h += 12;
  return `${String(h).padStart(2, "0")}:${minute}`;
}

export default function TimeInput({ value, onChange, testId }) {
  const { hour, minute, meridiem } = parse24h(value);

  const emit = (h, m, mer) => onChange(to24h(h, m, mer));

  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      <Select value={hour} onValueChange={(v) => emit(v, minute || "00", meridiem || "AM")}>
        <SelectTrigger className="w-[58px] px-2" data-testid={`${testId}-hour`}><SelectValue placeholder="--" /></SelectTrigger>
        <SelectContent>
          {HOURS.map((h) => <SelectItem key={h} value={h}>{h}</SelectItem>)}
        </SelectContent>
      </Select>
      <span className="text-muted-foreground">:</span>
      <Select value={minute} onValueChange={(v) => emit(hour || "12", v, meridiem || "AM")}>
        <SelectTrigger className="w-[62px] px-2" data-testid={`${testId}-minute`}><SelectValue placeholder="--" /></SelectTrigger>
        <SelectContent>
          {MINUTES.map((m) => <SelectItem key={m} value={m}>{m}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={meridiem} onValueChange={(v) => emit(hour || "12", minute || "00", v)}>
        <SelectTrigger className="w-[66px] px-2" data-testid={`${testId}-meridiem`}><SelectValue placeholder="AM" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="AM">AM</SelectItem>
          <SelectItem value="PM">PM</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
